import React from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { t } from "../utils/i18n";
import { Trophy } from "lucide-react";

// Rebaptisé "OLTODO Creator" — programme de récompenses pour les organisateurs (plus tu
// organises d'événements payants et de Lives vus, plus tu gagnes), teaser uniquement pour
// l'instant : le mécanisme réel de récompense arrive dans quelques mois, voir "coming_soon_title"
// déjà réutilisé ailleurs dans l'app. Toujours un stub volontaire, juste repositionné.
export default function Premium() {
  const navigate = useNavigate();
  const { lang } = useApp();
  return (
    <div style={{ maxWidth: 480, margin: "0 auto", padding: "20px 20px 40px", textAlign: "center" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 40 }}>
        <button onClick={() => navigate(-1)} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 20, padding: 0 }}>←</button>
      </div>
      <div style={{ width: 64, height: 64, borderRadius: "50%", backgroundColor: "#0a0a0a", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px" }}>
        <Trophy size={28} color="white" strokeWidth={1.6} />
      </div>
      <h1 style={{ fontSize: 20, fontWeight: 800, marginBottom: 20 }}>{t(lang, "premium_title")}</h1>
      <h2 style={{ fontSize: 26, fontWeight: 800, margin: "0 0 14px" }}>{t(lang, "creator_program_title")}</h2>
      <p style={{ fontSize: 14, color: "#666", lineHeight: 1.6, marginBottom: 24 }}>{t(lang, "creator_program_body")}</p>
      <p style={{ fontSize: 13, fontWeight: 700, color: "#999", textTransform: "uppercase", letterSpacing: 0.5 }}>{t(lang, "coming_soon_title")}</p>
    </div>
  );
}
